import { TFunction } from 'i18next';
import _noop from 'lodash/noop';
import { FormTemplateQuestionField } from 'graphql-common';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';

export type Props = Pick<
  FormTemplateQuestionField,
  | FormTemplateFieldNames.Kind
  | FormTemplateFieldNames.Options
  | FormTemplateFieldNames.Settings
  | FormTemplateFieldNames.Required
>;

export interface ComponentProps extends Props {
  t: TFunction<'translation', undefined>;
}

export const defaultProps = {
  onChange: _noop,
  disabled: true,
};
